// assets/paket-consent.js
// HALI — Pflicht-Checkbox „Widerrufsverzicht" für Planungspakete im Warenkorb/Drawer.
//
// Wird GLOBAL über snippets/cart-products.liquid geladen (initialer Seitenaufbau),
// NICHT im consent-Snippet — per Morph injizierte <script>-Tags würden nicht laufen.
//
// Die DAUERHAFTE Checkout-Sperre rendert serverseitig cart-summary.liquid (gated über
// das Cart-Attribut, morph-fest, da Horizon den Cart in place morpht). Dieses Modul
// ergänzt nur:
//   1. Sofort-Feedback beim Klick auf die Checkbox (ohne Re-Render),
//   2. Speichern des Cart-Attributs,
//   3. enforceGates(): nach jedem cart:update Button-Zustand erneut aus der Checkbox spiegeln,
//   4. Leeren des Attributs, sobald kein Planungspaket mehr im Warenkorb liegt
//      (über den echten Cart-Stand, damit es auch bei leerem Warenkorb greift, wo gar
//       kein consent-Element gerendert wird).
// Alle Listener hängen am document (Modul-Scope) und überleben Morphs.

// MUSS mit Handle-Liste / Attribut-Key in snippets/cart-summary.liquid übereinstimmen.
const PLANUNGSPAKET_HANDLES = ['planungspaket-basic', 'planungsgspaket-basic', 'planungspaket-pro', 'planungsgspaket-pro'];
const CONSENT_ATTR_KEY = 'Widerrufsverzicht (Planungsleistung)';

function cartBase() {
  const root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  return root.replace(/\/$/, '');
}

function postAttribute(value) {
  return fetch(cartBase() + '/cart/update.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
    body: JSON.stringify({ attributes: { [CONSENT_ATTR_KEY]: value } }),
  });
}

// Spiegelt den Checkbox-Zustand sofort auf die Buttons im selben Cart-Container.
function reflectState(checkbox) {
  const root = checkbox.closest('.cart-summary, .cart-drawer__summary') || document;
  const confirmed = checkbox.checked;

  const checkoutBtn = root.querySelector('#checkout');
  if (checkoutBtn) checkoutBtn.disabled = !confirmed;

  const express = root.querySelector('.additional-checkout-buttons');
  if (express) express.classList.toggle('additional-checkout-buttons--blocked', !confirmed);

  const hint = root.querySelector('[data-consent-hint]');
  if (hint) hint.hidden = confirmed;
}

document.addEventListener('change', (event) => {
  const target = event.target;
  if (!(target instanceof HTMLInputElement) || !target.matches('[data-consent-checkbox]')) return;

  const consent = target.closest('[data-consent]');
  reflectState(target);
  postAttribute(target.checked ? (consent && consent.dataset.attrValue) || '' : '').catch(() => {
    // Sicherer Default: bei Fehler Häkchen zurücknehmen, Sperre bleibt aktiv.
    target.checked = false;
    reflectState(target);
  });
});

// Erzwingt die Sperre nach jedem Cart-Update neu aus dem (serverseitig korrekt
// gerenderten) Checkbox-Zustand — morph-fest, weil es nach dem Morph läuft.
function enforceGates() {
  document.querySelectorAll('[data-consent-checkbox]').forEach((cb) => {
    if (cb instanceof HTMLInputElement) reflectState(cb);
  });
}

// Leert das Attribut, sobald kein Planungspaket mehr im Warenkorb liegt — auch bei
// leerem Warenkorb (kein consent-Element im DOM). Entscheidung über den echten Cart.
async function clearOrphanedAttribute() {
  try {
    const cart = await fetch(cartBase() + '/cart.js', { headers: { Accept: 'application/json' } }).then((r) => r.json());
    const hasPaket = cart.items.some((i) => PLANUNGSPAKET_HANDLES.includes(i.handle));
    if (!hasPaket && cart.attributes && cart.attributes[CONSENT_ATTR_KEY]) {
      await postAttribute('');
    }
  } catch (e) {
    /* still – Attribut bleibt, wird beim nächsten Cart-Update erneut geprüft */
  }
}

// `cart:update` wird synchron VOR dem Morph dispatcht — erst nach dem Task prüfen.
document.addEventListener('cart:update', () =>
  queueMicrotask(() => {
    enforceGates();
    clearOrphanedAttribute();
  })
);
document.addEventListener('DOMContentLoaded', enforceGates);
enforceGates();
